import { useMutation } from '@tanstack/react-query';

import {
  API_ENDPOINT,
  type ClientApiV1AccountsProfileImageCreateResponse,
  type useClientApiV1AccountsProfileImageCreateMutation,
} from '../../resources/@types/accountSchema';
import { accountFetcher } from '../../resources/Fetcher';

/**
 * multipart/form-data 형식으로 프로필 이미지를 업로드합니다.
 * 코드젠은 해당 형식을 지원하지 않으므로, fetch를 이용하여 직접 요청을 보냅니다.
 */
function useClientAccountProfileImageUploadMutation(
  options?: Parameters<typeof useClientApiV1AccountsProfileImageCreateMutation>[0]['options'],
) {
  return useMutation(({ file }: { file: File }) => {
    const formData = new FormData();
    formData.append('profileImage', file);

    return accountFetcher.post<ClientApiV1AccountsProfileImageCreateResponse>(
      API_ENDPOINT.CLIENT_V1_ACCOUNTS_PROFILE_IMAGE,
      formData,
    );
  }, options);
}

export default useClientAccountProfileImageUploadMutation;
